var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fdc-container"},[_c('project',{staticClass:"status"}),_c('index-status',{staticClass:"status"}),_c('cost',{staticClass:"status"}),_c('test',{staticClass:"status"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }